import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidateInputDirective } from './directives/validate-input.directive';
import { ViewLeadComponent } from './dialog-modals/view-lead/view-lead.component';
import { AddleadComponent } from './dialog-modals/addlead/addlead.component';
import { AssignleadComponent } from './dialog-modals/assignlead/assignlead.component';
import { FilterLeadComponent } from './dialog-modals/filter-lead/filter-lead.component';
import { MatNativeDateModule } from '@angular/material/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedService } from './services/shared.service';
import { ErrorService } from './services/error.service';
import { HttpService } from './services/http.service';
// import { RequestOptions, XHRBackend } from '@angular/http';
import { RejectleadComponent } from './dialog-modals/rejectlead/rejectlead.component';
import { ConfirmationComponent } from './dialog-modals/confirmation/confirmation.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { StatusComponent } from './dialog-modals/status/status.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { TermsAndConditionsComponent } from './dialog-modals/terms-and-conditions/terms-and-conditions.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@NgModule({ declarations: [
        ValidateInputDirective,
        ViewLeadComponent,
        AddleadComponent,
        AssignleadComponent,
        FilterLeadComponent,
        RejectleadComponent,
        StatusComponent,
        ConfirmationComponent,
        TermsAndConditionsComponent
    ],
    exports: [ValidateInputDirective, ViewLeadComponent, AddleadComponent, AssignleadComponent, FilterLeadComponent, RejectleadComponent], imports: [CommonModule,
        MatDialogModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgSelectModule,
        FormsModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule], providers: [
        ErrorService,
        HttpService,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class UtilsModule { }
